import { ManifestApiModel } from '~/lib/api/smartsend/types';
import { ExtendedOrderCache } from './ExtendedOrderCache';

export const UpdateManifestCache = (providerId: string, accountId: string, manifests: ManifestApiModel[]) => {
  manifests.forEach((m) => {
    m.ManifestOrderLines.forEach((o) => {
      // Remove from Both
      ExtendedOrderCache.preManifestedOrderLineIds = ExtendedOrderCache.preManifestedOrderLineIds.filter(
        (x) => x.SmartSendId != o.SmartSendId
      );
      ExtendedOrderCache.manifestedOrderLineIds = ExtendedOrderCache.manifestedOrderLineIds.filter(
        (x) => x.SmartSendId != o.SmartSendId
      );

      // Add updated record
      if (m.Status === 'DRAFT') {
        ExtendedOrderCache.preManifestedOrderLineIds.push({
          OrderLineId: o.OrderLineId,
          SmartSendId: o.SmartSendId,
          ManifestId: m.Id,
          ProviderId: providerId,
          AccountId: accountId
        });
      } else {
        ExtendedOrderCache.manifestedOrderLineIds.push({
          OrderLineId: o.OrderLineId,
          SmartSendId: o.SmartSendId,
          ManifestId: m.Id,
          ProviderId: providerId,
          AccountId: accountId
        });
      }
    });
  });
};
